import { render, staticRenderFns } from "./calvedAbortedList.vue?vue&type=template&id=a4b8b21c&scoped=true&"
import script from "./calvedAbortedList.vue?vue&type=script&lang=js&"
export * from "./calvedAbortedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b8b21c",
  null
  
)

export default component.exports